export const IMAGE_UPLOAD_MAX_SIZE = 500 * 1024;
// サーバ側で登録可能な形式と揃える
export const IMAGE_UPLOAD_ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif"];

export const IMAGE_UPLOAD_SIZE_WARNING =
  "ファイルの推奨サイズを超過しています。";
export const IMAGE_UPLOAD_TYPE_ERROR =
  "画像のアップロードに失敗しました。推奨ファイル形式をご確認ください。";

/**
 * 画像選択時のチェック結果を返す。
 * - jpg/png/gif かつ推奨サイズ超過なし: メッセージなし、登録可
 * - jpg/png/gif かつ推奨サイズ超過: メッセージあり、登録可
 * - それ以外: メッセージあり、登録不可
 *
 * @returns {{ message: string|null, allowUpload: boolean }}
 */
export const getImageUploadWarning = (file) => {
  if (!file || !file.raw) {
    return { message: IMAGE_UPLOAD_TYPE_ERROR, allowUpload: false };
  }

  if (!IMAGE_UPLOAD_ALLOWED_TYPES.includes(file.raw.type)) {
    return { message: IMAGE_UPLOAD_TYPE_ERROR, allowUpload: false };
  }

  if (file.raw.size > IMAGE_UPLOAD_MAX_SIZE) {
    return { message: IMAGE_UPLOAD_SIZE_WARNING, allowUpload: true };
  }

  return { message: null, allowUpload: true };
};
